import React, { useContext } from 'react';
import { useQuery } from 'react-apollo';
import { BasePage, StaticContext, FourOhFourError } from '@sm/webassets';
import Layout from '~app/components/Survey/Layout';
import Header from '~app/components/Survey/Header';
import QuizScoreSummary from '~app/components/Survey/QuizScoreSummary';
import SurveyTitle from '~app/components/Survey/SurveyTitle';
import SurveyPages from '~app/components/Survey/SurveyPages';
import ActionGroup from '~app/components/Survey/ActionGroup';
import Footer from '~app/components/Survey/Footer';
import { getSurveyFromCollector, getSurveyWithResponses } from './QuizResult.graphql';
import quizScore from './data/quizScore';
import formatSurvey from './helper/transform';
import './quiz-result.scss';

const QuizResult = () => {
  const { sm } = useContext(StaticContext);
  const collectorId = sm?.smParams?.cid;
  const respondentId = sm?.smParams?.r;
  const qrUrl = sm?.qaDoneUrl || '/';

  const { loading: loadingCollector, error: errorCollector, data: collectorData } = useQuery(getSurveyFromCollector, {
    variables: {
      collectorId,
    },
  });

  if (errorCollector) {
    throw errorCollector;
  }

  const { loading: loadingRespondent, error: errorRespondent, data: respondentData } = useQuery(
    getSurveyWithResponses,
    {
      skip: !collectorData || loadingCollector,
      variables: {
        surveyId: collectorData?.collector?.surveyId,
        respondentId,
      },
    }
  );

  if (errorRespondent) {
    throw errorRespondent;
  }
  if (!loadingRespondent && respondentData && respondentData.respondent === null) {
    return <FourOhFourError />;
  }

  const surveyData = respondentData?.respondent?.survey;
  const surveyLogo = surveyData?.design?.logo;
  const surveyTitle = surveyData?.title || '';
  const surveyPages = surveyData?.pages?.items;
  const surveyResults = respondentData?.respondent?.results?.items;
  const surveyWithResults = formatSurvey(surveyResults);

  return (
    <BasePage
      actionFlow="QuizResults"
      pageId="QuizResults"
      legacyWeb="respweb"
      includeHeader={false}
      includeFooter={false}
    >
      <Layout isRTL={false}>
        <Header logo={surveyLogo} />
        <QuizScoreSummary score={quizScore} />
        <SurveyTitle title={surveyTitle} />
        <SurveyPages pages={surveyPages} survey={surveyWithResults} />
        <ActionGroup qrDoneUrl={qrUrl} />
        <Footer />
      </Layout>
    </BasePage>
  );
};

export default QuizResult;
